module.exports = __webpack_public_path__ + "assets/adobe-audience-manager.72ea3396.svg";